import JumpstartUnit from './JumpstartUnit';

interface JamData {
  sitename?: string;
  site?: string;
  adunit?: string;
  prod?: string;
  subprod?: string;
  year?: string;
  make?: string;
  model?: string;
  fuel?: string;
  type?: string;
  style?: string;
  pubtemplate?: string;
}

// jumpstart : ensighten
const JUMPSTART_MAPPING = Object.freeze({
  mak: 'make',
  mod: 'model',
  yr: 'year',
  style: 'style',
  type: 'type',
  fuel: 'fuel',
  prod: 'prod',
  subprod: 'subprod',
  pubtemplate: 'pubtemplate',
  adflow: 'adflow',
});

interface EnsightenConfig {
  make?: string;
  model?: string;
  year?: string;
  style?: string;
  type?: string;
  fuel?: string;
  prod?: string;
  subprod?: string;
  pubtemplate?: string;
}

type JumpstartVars = Record<string, any>;

function convertJumpstartVarsToEnsightenVars(jumpstartVars: JumpstartVars): EnsightenConfig {
  const ensightenVars: EnsightenConfig = {};

  Object.entries(JUMPSTART_MAPPING).forEach(([jumpstartVar, ensightenVar]) => {
    const value = jumpstartVars[jumpstartVar];

    (ensightenVars as any)[ensightenVar] = value ? String(value) : '';
  });

  return ensightenVars;
}

// Jumsptart docs about ensiten vars:
// https://pubguide.jumpstartauto.net/docs/ensighten-tag-container
export function setEnsightenVars(adUnit: string, jumpstartVars: JumpstartVars): JamData {
  const jumpstartUnit = new JumpstartUnit(adUnit);

  const ensightenVars = {
    sitename: 'autolist.com',
    site: jumpstartUnit.site,
    adunit: jumpstartUnit.adunit,
    ...convertJumpstartVarsToEnsightenVars(jumpstartVars),
  };

  (global as any).jamData = ensightenVars;

  return ensightenVars;
}

export default { setEnsightenVars };
